import { ReactNode } from 'react'

import { createRoot } from 'react-dom/client'

import { Message, MessageType } from './message'
import s from './styles.module.scss'

let messageContainer: HTMLDivElement | null = null

const getMessageContainer = () => {
  if (!messageContainer) {
    messageContainer = document.createElement('div')
    messageContainer.className = s.messageContainer
    document.body.appendChild(messageContainer)
  }
  return messageContainer
}

export function showMessage(
  type: MessageType,
  content: ReactNode,
  duration?: number,
) {
  const container = getMessageContainer()
  const messageElement = document.createElement('div')
  container.appendChild(messageElement)
  const root = createRoot(messageElement)
  root.render(
    <Message
      type={type}
      content={content}
      duration={duration}
      onClose={() => {
        root.unmount()
        container.removeChild(messageElement)
      }}
    />,
  )
}

export const message = {
  success: (content: ReactNode, duration?: number) => {
    showMessage('success', content, duration)
  },
  error: (content: ReactNode, duration?: number) => {
    showMessage('error', content, duration)
  },
  warning: (content: ReactNode, duration?: number) => {
    showMessage('warning', content, duration)
  },
  info: (content: ReactNode, duration?: number) => {
    showMessage('info', content, duration)
  },
  copy: (content: ReactNode, duration?: number) => {
    showMessage('copy', content, duration)
  },
}
